export default [
  {
    route: 'onework-dashboard',
    title: 'onework-dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    resource: 'Onework-dashboard',
    action: 'read',
  },
  {
    route: null,
    title: 'onework-users',
    slug: 'users',
    icon: 'UsersIcon',
    resource: 'Onework-users',
    i18n: 'Users',
    children: [
      {
        route: 'onework-users-admin',
        title: 'onework-users-admin',
        slug: 'userAdmin',
        icon: 'BriefcaseIcon',
        i18n: 'Admin',
        resource: 'Onework-users-admin',
        action: 'read',
      },
      {
        route: 'onework-users-staff',
        title: 'onework-users-staff',
        slug: 'userStaff',
        icon: 'PackageIcon',
        i18n: 'Staff',
        resource: 'Onework-users-staff',
        action: 'read',
      },
    ],
  },
]
